var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProperty1IconamoonArrowUp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4471 9.46967C13.74 9.76256 13.74 10.2374 13.4471 10.5303L8.44708 15.5303C8.15418 15.8232 7.67931 15.8232 7.38642 15.5303C7.09352 15.2374 7.09352 14.7626 7.38642 14.4697L11.8561 10L7.38642 5.53033C7.09353 5.23744 7.09353 4.76256 7.38642 4.46967C7.67931 4.17678 8.15419 4.17678 8.44708 4.46967L13.4471 9.46967Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty1IconamoonArrowUp2);
export default __webpack_public_path__ + "static/media/Property 1=iconamoon_arrow-up-2.0cab8f647e4072334b1b2b8d806e84ec.svg";
export { ForwardRef as ReactComponent };